import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handlers } from '../../helpers/helpers';
import { patientsService } from "../../services/patient";
import { utils } from '../../utils/messageAlerts';

const useGetPatientData = ({ countryCode }) => {
  const navigate = useNavigate();
  const [data, setData] = useState();
  const [surveys, setSurveys] = useState();
  const [params, setParams] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setData();
    setSurveys();
    setIsLoading(false)

    if (params) {
      setIsLoading(true);
      const data = {
        ...params,
        document_number: params.documentNumber,
        document_type: params.documentType,
      };
      delete data.documentNumber;
      delete data.documentType;
      patientsService.getExamsOfDay(data)
        .then(response => {
          if (response.consultations || response.exams) {
            setData(response);
          } else {
            utils.messageAlert('error', 'Tus datos no registran exámenes el día de hoy');
          }
        })
        .catch(() => {
          utils.messageAlert('error', 'Ha ocurrido un error inesperado');
        })
        .finally(() => {
          setIsLoading(false);
        })
    }
  }, [params]);

  useEffect(() => {
    if (surveys) {
      handlers.handleUserData(surveys);
      navigate(`/mis-examenes/${countryCode}/encuesta-salud`);
    }

    if (data) {
      handlers.handleUserData(data);
      navigate(`/mis-examenes/${countryCode}/estado`);
    }
  }, [data, navigate, surveys, countryCode]);

  useEffect(() => {
    const storageData = JSON.parse(localStorage.getItem('userData'));
    const surveyStorage = JSON.parse(localStorage.getItem('surveyData'));

    if (storageData) {
      setData(storageData);
    }

    if (surveyStorage) {
      setSurveys(surveyStorage);
    }
  }, []);

  return { data, isLoading, setParams };
}

export default useGetPatientData;
